import script from "./Address.vue?vue&type=script&setup=true&lang=ts"
export * from "./Address.vue?vue&type=script&setup=true&lang=ts"

import "./Address.vue?vue&type=style&index=0&id=9626a192&lang=scss"

const __exports__ = script;

export default __exports__